module.exports = __webpack_public_path__ + "img/placeholder.3b1e63f4.webp";